import React, { useEffect, useState } from "react";
import { FiFileText, FiTag, FiFolder } from "react-icons/fi";
import api, { apiError } from "../../lib/api";
import RenderToast from "../../appcomponents/RenderToast";
import styles from "./Dashboard.module.css";

const CARDS = [
  { key: "total_blogs", label: "Total Blogs", icon: FiFileText, accent: "#0e9ce8" },
  { key: "total_categories", label: "Total Categories", icon: FiFolder, accent: "#7c3aed" },
  { key: "total_tags", label: "Total Tags", icon: FiTag, accent: "#16a34a" },
];

export default function Dashboard() {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await api.get("/api/dashboard/stats.php");
        if (active) setStats(data.data || {});
      } catch (err) {
        RenderToast({ type: "error", message: apiError(err) });
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.pageHead}>
        <h1 className={styles.title}>Dashboard</h1>
        <p className={styles.subtitle}>Overview of your content</p>
      </div>

      <div className={styles.cards}>
        {CARDS.map(({ key, label, icon: Icon, accent }) => (
          <div key={key} className={styles.card}>
            <div className={styles.cardIcon} style={{ background: `${accent}1a`, color: accent }}>
              <Icon size={26} />
            </div>
            <div className={styles.cardBody}>
              <span className={styles.cardValue}>
                {loading ? <span className={styles.skeleton} /> : stats[key] ?? 0}
              </span>
              <span className={styles.cardLabel}>{label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
